// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Results General Section
--------------------------------------------------------------*/
.B47vn65N5Oo9j9zgLJCo {
  padding-top: 0px !important;
}
.B47vn65N5Oo9j9zgLJCo .Iu3F3h461eVVdW0OzFDg {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.062745098);
  margin: 10px 0;
  padding: 20px;
  display: flex;
  height: stretch;
}
@media (max-width: 992px) {
  .B47vn65N5Oo9j9zgLJCo .Iu3F3h461eVVdW0OzFDg {
    padding: 1.5rem;
  }
}
.B47vn65N5Oo9j9zgLJCo a.Iu3F3h461eVVdW0OzFDg h3:hover {
  color: #0068F5;
}
.B47vn65N5Oo9j9zgLJCo a.Iu3F3h461eVVdW0OzFDg:hover {
  background-color: #F7F8FA;
}
.B47vn65N5Oo9j9zgLJCo .zNYK4sgjsABXgtxITOQy {
  height: 27px;
  border-radius: 8px;
  background-color: #FFECC2;
  width: fit-content;
  padding: 3px 15px;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 15px;
}
.B47vn65N5Oo9j9zgLJCo .uk6DfD8sXFUh4N45mETG .gDnvUUe1ABwjQCzhMn2l {
  font-size: 1.25rem;
  font-weight: 700;
  color: color-mix(in srgb, var(--heading-color), transparent 50%);
  font-family: var(--heading-font);
  margin-bottom: 1rem;
  transition: all 0.3s ease-in-out;
}
.B47vn65N5Oo9j9zgLJCo .uk6DfD8sXFUh4N45mETG h3 {
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  color: #0C3058;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  font-family: "Rubik";
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .B47vn65N5Oo9j9zgLJCo .uk6DfD8sXFUh4N45mETG h3 {
    margin-bottom: 1rem;
  }
}
.B47vn65N5Oo9j9zgLJCo .ZkhMEdhNbEJzV0qwzUj7 {
  margin-top: 10px;
}
.B47vn65N5Oo9j9zgLJCo .ZkhMEdhNbEJzV0qwzUj7 p {
  margin-bottom: 0;
  color: #0C3058;
  line-height: 24px;
  font-size: 16px;
  font-weight: 300;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.B47vn65N5Oo9j9zgLJCo .ZkhMEdhNbEJzV0qwzUj7 p img {
  max-width: 100%;
  height: auto;
}
.B47vn65N5Oo9j9zgLJCo .WdliJePoZ3XkUAmZasxh {
  margin-top: 10px;
}
.B47vn65N5Oo9j9zgLJCo .WdliJePoZ3XkUAmZasxh span {
  display: inline-block;
  color: #000000;
  margin: 6px 0 0 10px;
  width: 60px;
}
.B47vn65N5Oo9j9zgLJCo .WdliJePoZ3XkUAmZasxh ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline;
}
.B47vn65N5Oo9j9zgLJCo .WdliJePoZ3XkUAmZasxh ul li {
  display: inline-block;
  background-color: #EBF3FF;
  color: #000000;
  border-radius: 50px;
  font-size: 14px;
  padding: 5px 15px;
  margin: 4px 0px 4px 8px;
  display: inline-block;
}
.B47vn65N5Oo9j9zgLJCo .e2oo5pijXhoTJNPxcdp6 {
  margin-top: 10px;
}
.B47vn65N5Oo9j9zgLJCo .e2oo5pijXhoTJNPxcdp6 span {
  display: inline-block;
  color: #000000;
  font-size: 16px;
  margin-left: 10px;
  width: 60px;
}
.B47vn65N5Oo9j9zgLJCo .e2oo5pijXhoTJNPxcdp6 ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline;
}
.B47vn65N5Oo9j9zgLJCo .e2oo5pijXhoTJNPxcdp6 ul li {
  background-color: #FFECC2;
  color: #000000;
  border-radius: 50px;
  font-size: 14px;
  padding: 5px 15px;
  margin: 0 0 0 8px;
  display: inline-block;
  transition: 0.3s;
}
.B47vn65N5Oo9j9zgLJCo .e2oo5pijXhoTJNPxcdp6 ul li span {
  padding-left: 5px;
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchResults/resultsGeneral/ResultsGeneral.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,2BAAA;AACJ;AACI;EACI,yBAAA;EACA,mBAAA;EACA,uDAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AACR;AACQ;EATJ;IAUQ,eAAA;EAEV;AACF;AAGY;EACI,cAAA;AADhB;AAKQ;EACI,yBAAA;AAHZ;AAOI;EACI,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AALR;AASQ;EACI,kBAAA;EACA,gBAAA;EACA,gEAAA;EACA,gCAAA;EACA,mBAAA;EACA,gCAAA;AAPZ;AAUQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AARZ;AAUY;EAbJ;IAcQ,mBAAA;EAPd;AACF;AAWI;EACI,gBAAA;AATR;AAWQ;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AATZ;AAWY;EACI,eAAA;EACA,YAAA;AAThB;AAcI;EACI,gBAAA;AAZR;AAcQ;EACI,qBAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;AAZZ;AAeQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAbZ;AAeY;EACI,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;AAbhB;AAkBI;EACI,gBAAA;AAhBR;AAkBQ;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAhBZ;AAmBQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAjBZ;AAmBY;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AAjBhB;AAmBgB;EACI,iBAAA;EACA,gEAAA;EACA,eAAA;AAjBpB","sourcesContent":["/*--------------------------------------------------------------\r\n# Results General Section\r\n--------------------------------------------------------------*/\r\n.results-general {\r\n    padding-top: 0px !important;\r\n\r\n    .result-item {\r\n        background-color: #ffffff;\r\n        border-radius: 16px;\r\n        box-shadow: 0px 4px 10px 0px #00000010;\r\n        margin: 10px 0;\r\n        padding: 20px;\r\n        display: flex;\r\n        height: stretch;\r\n\r\n        @media (max-width: 992px) {\r\n            padding: 1.5rem;\r\n        }\r\n    }\r\n\r\n    a.result-item {\r\n        h3 {\r\n            &:hover {\r\n                color: #0068F5;\r\n            }\r\n        }\r\n\r\n        &:hover {\r\n            background-color: #F7F8FA;\r\n        }\r\n    }\r\n\r\n    .result-type {\r\n        height: 27px;\r\n        border-radius: 8px;\r\n        background-color: #FFECC2;\r\n        width: fit-content;\r\n        padding: 3px 15px;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        color: #000000;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .result-title {\r\n        .result-number {\r\n            font-size: 1.25rem;\r\n            font-weight: 700;\r\n            color: color-mix(in srgb, var(--heading-color), transparent 50%);\r\n            font-family: var(--heading-font);\r\n            margin-bottom: 1rem;\r\n            transition: all 0.3s ease-in-out;\r\n        }\r\n\r\n        h3 {\r\n            font-size: 20px;\r\n            line-height: 24px;\r\n            font-weight: 500;\r\n            color: #0C3058;\r\n            display: -webkit-box;\r\n            -webkit-box-orient: vertical;\r\n            -webkit-line-clamp: 2;\r\n            line-clamp: 2;\r\n            overflow: hidden;\r\n            font-family: 'Rubik';\r\n            margin-bottom: 0;\r\n\r\n            @media (max-width: 991.98px) {\r\n                margin-bottom: 1rem;\r\n            }\r\n        }\r\n    }\r\n\r\n    .result-content {\r\n        margin-top: 10px;\r\n\r\n        p {\r\n            margin-bottom: 0;\r\n            color: #0C3058;\r\n            line-height: 24px;\r\n            font-size: 16px;\r\n            font-weight: 300;\r\n            overflow: hidden;\r\n            display: -webkit-box;\r\n            -webkit-line-clamp: 3;\r\n            line-clamp: 3;\r\n            -webkit-box-orient: vertical;\r\n\r\n            img {\r\n                max-width: 100%;\r\n                height: auto;\r\n            }\r\n        }\r\n    }\r\n\r\n    .result-tags {\r\n        margin-top: 10px;\r\n\r\n        span {\r\n            display: inline-block;\r\n            color: #000000;\r\n            margin: 6px 0 0 10px;\r\n            width: 60px;\r\n        }\r\n\r\n        ul {\r\n            list-style: none;\r\n            padding: 0;\r\n            margin: 0;\r\n            display: inline;\r\n\r\n            li {\r\n                display: inline-block;\r\n                background-color: #EBF3FF;\r\n                color: #000000;\r\n                border-radius: 50px;\r\n                font-size: 14px;\r\n                padding: 5px 15px;\r\n                margin: 4px 0px 4px 8px;\r\n                display: inline-block;\r\n            }\r\n        }\r\n    }\r\n\r\n    .categories {\r\n        margin-top: 10px;\r\n\r\n        span {\r\n            display: inline-block;\r\n            color: #000000;\r\n            font-size: 16px;\r\n            margin-left: 10px;\r\n            width: 60px;\r\n        }\r\n\r\n        ul {\r\n            list-style: none;\r\n            padding: 0;\r\n            margin: 0;\r\n            display: inline;\r\n\r\n            li {\r\n                background-color: #FFECC2;\r\n                color: #000000;\r\n                border-radius: 50px;\r\n                font-size: 14px;\r\n                padding: 5px 15px;\r\n                margin: 0 0 0 8px;\r\n                display: inline-block;\r\n                transition: 0.3s;\r\n\r\n                span {\r\n                    padding-left: 5px;\r\n                    color: color-mix(in srgb, var(--default-color), transparent 60%);\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"results-general": `B47vn65N5Oo9j9zgLJCo`,
	"result-item": `Iu3F3h461eVVdW0OzFDg`,
	"result-type": `zNYK4sgjsABXgtxITOQy`,
	"result-title": `uk6DfD8sXFUh4N45mETG`,
	"result-number": `gDnvUUe1ABwjQCzhMn2l`,
	"result-content": `ZkhMEdhNbEJzV0qwzUj7`,
	"result-tags": `WdliJePoZ3XkUAmZasxh`,
	"categories": `e2oo5pijXhoTJNPxcdp6`
};
export default ___CSS_LOADER_EXPORT___;
